import React, { useState } from 'react';
import { MessageCircle, X, Send } from 'lucide-react';

const FloatingContactForm = () => {
  const contactEmail = 'inarchdesignstudiovashi@gmail.com';

  const [isOpen, setIsOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    message: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify({
          access_key: 'bf531cbe-01a2-4964-b571-e0128f00ebc9',
          to: contactEmail,
          from_name: formData.name,
          subject: `Quick Inquiry from ${formData.name}`,
          name: formData.name,
          phone: formData.phone,
          message: formData.message,
        }),
      });

      const data = await response.json();

      if (data.success) {
        setIsSubmitted(true);
        setTimeout(() => {
          setIsSubmitted(false);
          setIsOpen(false);
          setFormData({ name: '', phone: '', message: '' });
        }, 3000);
      }
    } catch (err) {
      console.error('Form submission error:', err);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      {/* Floating Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-[#B87333] rounded-full flex items-center justify-center shadow-lg hover:scale-110 transition-transform hover:bg-[#8b5a2b]"
        aria-label="Quick Contact Form"
      >
        {isOpen ? (
          <X size={28} className="text-white" />
        ) : (
          <MessageCircle size={28} className="text-white" />
        )}
      </button>

      {/* Form Popup */}
      {isOpen && (
        <div className="fixed bottom-24 right-6 z-50 w-80 bg-white rounded-lg shadow-2xl overflow-hidden animate-fade-in">
          <div className="bg-[#B87333] p-4">
            <h3 className="text-white font-medium">Quick Inquiry</h3>
            <p className="text-white/80 text-sm">Send us a message</p>
          </div>

          {isSubmitted ? (
            <div className="p-6 text-center">
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-3">
                <Send className="text-green-600" size={24} />
              </div>
              <p className="text-[#2C2C2C] font-medium">Message Sent!</p>
              <p className="text-[#6B6B6B] text-sm">We'll get back to you soon.</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="p-4 space-y-4">
              <div>
                <input
                  type="text"
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  className="w-full px-3 py-2 border border-[#E8E3DB] rounded-lg focus:outline-none focus:border-[#B87333] text-sm"
                  placeholder="Your Name *"
                  required
                />
              </div>
              <div>
                <input
                  type="tel"
                  value={formData.phone}
                  onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                  className="w-full px-3 py-2 border border-[#E8E3DB] rounded-lg focus:outline-none focus:border-[#B87333] text-sm"
                  placeholder="Phone Number *"
                  required
                />
              </div>
              <div>
                <textarea
                  value={formData.message}
                  onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                  className="w-full px-3 py-2 border border-[#E8E3DB] rounded-lg focus:outline-none focus:border-[#B87333] text-sm h-20 resize-none"
                  placeholder="Your Message *"
                  required
                />
              </div>
              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-[#B87333] text-white py-2.5 rounded-lg text-sm font-medium hover:bg-[#8b5a2b] transition-colors disabled:opacity-50"
              >
                {isSubmitting ? 'Sending...' : 'Send Message'}
              </button>
            </form>
          )}
        </div>
      )}
    </>
  );
};

export default FloatingContactForm;
